import React from 'react';
import loadingStyle from '../LoadingOverlay.module.css';

const Spinner = (props) => {
    return (
        <div className={loadingStyle.spinner}>
            {props.children}
        </div>
    )
}

export default Spinner;
